<script>
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {faSync} from "@fortawesome/free-solid-svg-icons/faSync"
    export default {
        components: {
            FontAwesomeIcon
        },
        props: {
            projectId: {
                required: true,
                type: Number
            },
            fileableType: {
                required: true,
                type: String
            },
            metaType: {
                required: true,
                type: String
            }
        },
        data() {
            return {           
                icons: {
                    refresh: faSync
                },
                queueRefresh: false,
            }
        },
        created() {
            // Allows Bulk Import Component to trigger refresh
            if(window.Bus) {
                window.Bus.$on('updateProjectImportHistory', (metaType) => {
                    if (Array.isArray(metaType) && metaType.includes(this.metaType)) {
                        this.refreshRecords();
                    } else if(typeof metaType === 'string' && metaType === this.metaType) {
                        this.refreshRecords();
                    }
                });
            }
        },
        computed: {
            bulkImportRecordsUrl() {
                return `/api/projects/${this.projectId}/bulk_import/logs?metaType=${this.metaType}`
            },
            spinRefresh() {
                return this.queueRefresh === true
            }
        },
        methods: {
            refreshRecords() {
                this.queueRefresh = true;

                if(window.Bus) {
                    window.Bus.$emit('updateFiles', this.metaType)
                }
            }
        }
    }
</script>

<template>
    <div class="flex flex-col my-3 mx-4">
        <div class="flex justify-between">
            <h4 class="text-md">
                Recent Imports
            </h4>

            <div>
                <font-awesome-icon :icon="icons.refresh" :spin="spinRefresh" @click="refreshRecords"></font-awesome-icon>
            </div>
        </div>
        <div class="flex flex-col import-history-container">
            <div>
                <v-grid
                    grid-type="divRow"
                    record-type="project-bulk-import-result-row"
                    :record-url="bulkImportRecordsUrl"
                    :use-json-api="true"
                    :queue-refresh.sync="queueRefresh"
                    :base-record-id="projectId"
                ></v-grid>
            </div>
        </div>
    </div>

</template>
